import { apiRequest } from "./common";

const getAlertList = async (pageNo, pageSize, searchText) => {
    const response = await apiRequest('get', `/alert?page=${pageNo}&limit=${pageSize}${searchText ? `&search=${searchText}` : ''}`);
    return response.data;
};

const getUpcomgAlert = async () => {
    const response = await apiRequest('get', `/alert/student/my-alerts`);
    return response.data;
};

const createAlert = async (data) => {
    const response = await apiRequest('post', `/alert`, data);
    return response.data;
};

const updateAlert = async (meetingId, data) => {
    const response = await apiRequest('put', `/alert/${meetingId}`, data);
    return response.data;
};


const deleteAlert = async (meetingId) => {
    const response = await apiRequest('delete', `/alert/${meetingId}`);
    return response.data;
};

export {
    getAlertList,
    getUpcomgAlert,
    createAlert,
    updateAlert,
    deleteAlert
}